import React, { useEffect, useState } from "react";
import { auth } from "../../FirebaseConfig";
import AdminAPI from "../../network/AdminAPI";
import SystemAPI from "../../network/SystemAPI";
import InBetweenOverlay from "../InBetweenOverlay";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from "../LanguageSwitcher";
export default function LoggedOut(){
    // const auth = getAuth(app)

    const { t } = useTranslation();

    const [logoURL, setLogoURL] = useState('')
    const [productName, setProductName] = useState('')
    const [showLoading, setShowLoading] = useState(false)
    const [buttonColorHexValue, setButtonColorHexValue] = useState('')
    const [backgroundColorHexValue, setBackgroundColorHexValue] = useState('')
    const [selectedLanguage, setSelectedLanguage] = useState('en')

    useEffect(() => {
        document.title = 'Logged Out | Oklahoma Department of Health';
        document.body.style.backgroundColor = 'black';
        setShowLoading(true)
        auth.signOut().then(() => {
            console.log(" signout successful")

            let currentURL = window.location.href;

            SystemAPI.getProductBrandingFromURL(currentURL).then(data => {
                let backgroundImageURL = data.ProductBackgroundImageURL;
                //@ts-ignore
                document.body.style.backgroundImage = `url(${backgroundImageURL}`;
                document.body.style.backgroundRepeat = "no-repeat";
                document.body.style.backgroundSize = "cover";

                setLogoURL(data.ProductLogoURL);
                setProductName(data.Name)
                setButtonColorHexValue(data.ProductButtonColorHexValue)
                setBackgroundColorHexValue(data.ProductAdminNavBackgroundColorHexValue)
                setShowLoading(false)
            })
        })
            .catch(e => {
                console.error(' an error occurred on logout', e)
            })


    }, [])

    return (
        <React.Fragment>
            <InBetweenOverlay showInBetween={true} zIndex={-10} />
            <div className={showLoading ? "d-none" : "container min-vh-100"}>
                <div className="row justify-content-center mt-5">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="card shadow">
                            <div className="card-title text-center border-bottom" style={{ "backgroundColor": backgroundColorHexValue, "borderRadius": "3px" }}>
                                <a href="/">
                                    <img src={logoURL}
                                        style={{ width: '200px', margin: '20px' }}
                                        className={'nav-logo'} alt={"Home | Oklahoma State Department of Health Immunization Service"}
                                    />
                                </a>
                            </div>
                            <div className="row text-center">
                                <div className="col-3"></div>
                                <div className="col-6">
                                    <LanguageSwitcher onChange={(language) => setSelectedLanguage(language)} />
                                </div>
                                <div className="col-3"></div>
                            </div>
                            <div className="card-body">
                                <div className="text-center">{t("Logged out successfully")}</div>
                                {/* <p className="text-center mt-3">To log in to the <b>{customerName} Portal</b> again, press the button below.</p> */}
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <a href={"/login"} role="button" className={"btn btn-lg text-light w-100"} style={{ backgroundColor: buttonColorHexValue }}>
                                            {t("Log In")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

